import { render, staticRenderFns } from "./SpinnerContainer.vue?vue&type=template&id=72e2df98&"
import script from "./SpinnerContainer.vue?vue&type=script&lang=ts&"
export * from "./SpinnerContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports